import styled from 'styled-components';

import { Button } from '@gympass/yoga';

export const Container = styled.div`
  display: grid;
  width: ${({ theme }) => theme.yoga.sizes.calendarEventContainerWidth}px;
`;

export const Content = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.yoga.spacing.small}px;
  justify-content: center;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xsmall}px;
`;

export const Title = styled.h2`
  color: ${({ theme }) => theme.yoga.colors.textPrimary};
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  font-size: ${({ theme }) => theme.yoga.fontSizes.large}px;
  line-height: ${({ theme }) => theme.yoga.lineHeights.xlarge}px;
`;

export const Footer = styled.footer`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
`;

export const StyledButtonOutline = styled(Button.Outline)`
  font-size: ${({ theme }) => theme.yoga.fontSizes.medium}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  align-items: center;
  justify-content: flex-start;
  text-align: start;
  margin-top: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.small}px;
`;

export const StyledButton = styled(Button)`
  margin-top: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.small}px;
`;
